export default {
  good(state) {
    return state.good
  },
  goods(state) {
    return state.goods
  },
  goodForm(state) {
    return state.goodForm
  },
  goodErrors(state) {
    return state.goodErrors
  },
  goodFilters(state) {
    return state.goodFilters
  },
}
